import * as z from "zod";
import { CompanySchema } from "@/pages/requests/components";

export type CompanySchemaType = z.infer<typeof CompanySchema>;

export enum ContractField {
  Companies = "Companies",
  ContractType = "ContractType",
  ContractNumber = "ContractNumber",
  SubContractor = "SubContractor",
}

export enum ContractFieldLabel {
  Companies = "Select company",
  ContractType = "Select contract type",
  ContractNumber = "Contract number",
  SubContractor = "Subcontractor",
}
